var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxPopup',{attrs:{"visible":_vm.showPop,"show-close-button":true,"show-title":true,"title":'Testing...',"height":"700px","width":"1000px"},on:{"hidden":_vm.onHidden}},[_vm._v(" jdePop ")])}
var staticRenderFns = []

export { render, staticRenderFns }